<template>
  <section class="config-group" aria-label="Search results">
      <div class="row">
        <div class="column">
          <h3>{{texts.global.basicSettings}}</h3>
          <RadioGroup class="row stretch" :items="radioItems" name="result-type" @input="onTypeChange" :key="radioKey"/>
          <div v-if="config.results.embedConfig !== undefined" class="row stretch" style="margin: 0.5em 0;">
            <label for="embed-url">{{texts.results.searchResultPage}}</label>
            <input id="embed-url" type="text" v-model="config.results.embedConfig.url" placeholder="/search-results" />
          </div>
          <Checkmark :label="texts.global.highlightQueryTerms" v-model="config.results.highlightQueryTerms"  checkbox-id="highlight-sr--i"/>
          <Checkmark :label="texts.results.linksOpenNewTab" v-model="config.results.linksOpenNewTab"  checkbox-id="new-tab--i"/>
          <Checkmark :label="texts.results.redirectOnSingle" v-model="config.results.redirectOnSingle"  checkbox-id="redirect-on-single--i"/>
          <Checkmark :label="texts.results.hideResultsWithoutImages" v-model="config.results.hideResultsWithoutImage"  checkbox-id="hide-missing-img--i"/>
          <Checkmark v-if="config.results.embedConfig===undefined && config.results.fullScreenConfig===undefined" :label="texts.results.showSearchBox" v-model="config.results.showSearchBoxLayover"  checkbox-id="show-sb--i"/>
           <div class="row stretch" style="margin: 0.5em 0;">
            <label for="sr-num--i">{{texts.results.num}}</label>
            <input id="sr-num--i" type="number" min="1" max="200" v-model="config.results.num"/>
          </div>
          <Checkmark :label="texts.results.showAll" @input="toggleAllResults" :value="config.results.moreResultsButton===undefined" checkbox-id="sr-show-all--i" />
          <div class="row stretch" style="margin: 0.5em 0;" v-if="config.results.moreResultsButton!==undefined">
            <label for="more-results--i">{{texts.results.moreResultsButton}}</label>
            <input type="text" id="more-results--i" v-model="config.results.moreResultsButton" style="width: 140px;"/>
          </div>
          <Checkmark :label="texts.results.infiniteScroll" v-if="config.results.moreResultsButton!==undefined" v-model="config.results.infiniteScroll" checkbox-id="sr-infinite-scroll--i" />
          <div class="row stretch" style="margin: 0.5em 0;" v-if="config.results.moreResultsButton!==undefined">
            <label for="page-size--i">{{texts.results.pageSize}}</label>
            <input type="number" id="page-size--i" v-model="config.results.moreResultsPagingSize"  style="width: 140px;"/>
          </div>
        </div>
        <div class="column">
          <h3>{{texts.results.texts}}</h3>
          <div class="row stretch" style="margin: 0.5em 0;">
            <label for="sr-caption--i">{{texts.results.caption}}</label>
            <input id="sr-caption--i" type="text" v-model="config.results.caption" />
          </div>
          <div class="row stretch" style="margin: 0.5em 0;">
            <label for="sr-correction--i">{{texts.results.queryCorrection}}</label>
            <input id="sr-correction--i" type="text" v-model="config.results.queryCorrectionText" />
          </div>
          <div class="row stretch" style="margin: 0.5em 0;">
            <label for="sr-empty--i">{{texts.results.noResults}}</label>
            <input id="sr-empty--i" type="text" v-model="config.results.noResultsText" />
          </div>
           <div v-if="config.results.fullScreenConfig!==undefined" class="row stretch" style="margin: 0.5em 0;">
            <label for="sr-fs-caption--i">{{texts.results.fullscreenCaption}}</label>
            <input id="sr-fs-caption--i" type="text" :placeholder="texts.results.fullscreenCaptionText" v-model="config.results.fullScreenConfig.caption"/>
          </div>
        </div>
        <div class="column">
          <h3>{{texts.results.layout}}</h3>
            <h4>{{texts.results.mobile}}</h4>
            <div class="row stretch">
            <SearchResultsLayoutGroup :config="config.layout.mobile" breakpoint="767" name="mobile"/>
          </div>
            <h4>{{texts.results.desktop}}</h4>
          <div class="row stretch">
            <SearchResultsLayoutGroup :config="config.layout.desktop" breakpoint="1199" name="desktop"/>
          </div>
        </div>
      </div>
  </section>
</template>

<script>
import Vue from "vue";
import RadioGroup from "../RadioGroup"
import Checkmark from "../Checkmark"
import SearchResultsLayoutGroup from './SearchResultsLayoutGroup'

export default {
  name: "SearchResults",
  components: {RadioGroup, Checkmark, SearchResultsLayoutGroup},
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  computed: {
    isLayover() {
      return (
        this.config.results.embedConfig === undefined &&
        this.config.results.fullScreenConfig === undefined
      );
    },
    isEmbed() {
      return this.config.results.embedConfig !== undefined;
    },
    isFullScreen() {
      return this.config.results.fullScreenConfig !== undefined;
    },
    radioItems(){
      return [
        {
          id: 'layover--i',
          isActive: this.isLayover,
          label: this.texts.results.layover,
          value: 'layover'
        },
        {
          id: 'embed--i',
          isActive: this.isEmbed,
          label: this.texts.results.embed,
          value: 'embed'
        },
        {
          id: 'fullscreen--i',
          isActive: this.isFullScreen,
          label: this.texts.results.fullscreen,
          value: 'fullscreen'
        }
      ]
    },
    canBeImageRepositioned(){
      const mobileType = this.config.layout.mobile.type;
      const desktopType = this.config.layout.desktop.type;
      return mobileType === 'masonry' || desktopType === 'masonry' || mobileType === 'grid' || desktopType === 'grid';
	},
  },
  data() {
	  return {
		  radioKey: 1
	  }
  },
  methods: {
    onTypeChange(value) {
      var fsConfig = undefined;
      var embedConfig = undefined;
      if (value === "embed") {
        embedConfig = { contentBlock: "#ss360-target" };
      } else if (value === "fullscreen") {
        fsConfig = { trigger: "#ss360-trigger", caption: this.texts.results.fullscreenCaptionText };
	  }
	  if (embedConfig === undefined) {
		  Vue.delete(this.config.results, 'embedConfig');
	   } else {
			Vue.set(this.config.results, "embedConfig", embedConfig);
	   } 
	   if (fsConfig === undefined) {
			Vue.delete(this.config.results, 'fullScreenConfig');
	   } else {
			Vue.set(this.config.results, "fullScreenConfig", fsConfig);
	   }
      if(fsConfig!==undefined){
        Vue.set(this.config.suggestions, "show", false);
	  }
	
    },
    toggleAllResults(isChecked) {
      if (isChecked) {
        Vue.set(this.config.results, "moreResultsButton", undefined);
      } else {
        Vue.set(this.config.results, "moreResultsButton", this.texts.results.showMoreResults);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/configuration/SearchResults.vue